import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import {
    debounceTime,
    distinctUntilChanged,
    Subject,
    Subscription
} from 'rxjs';

@Component({
    selector: 'app-search-input-with-debouncing',
    templateUrl: './search-input-with-debouncing.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./search-input-with-debouncing.component.scss']
})
export class SearchInputWithDebouncingComponent implements OnInit, OnDestroy {
    @Input() value: string = '';
    @Input() placeholder: string = 'Search';
    @Output() searchEvent = new EventEmitter<string>();

    searchSubject: Subject<string> = new Subject<string>();
    private searchSubscription: Subscription = new Subscription();

    ngOnInit(): void {
        this.searchSubscription = this.searchSubject
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((searchValue: string) => {
                this.searchEvent.emit(searchValue);
            });
    }

    onSearch(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.searchSubject.next(input.value);
    }

    ngOnDestroy(): void {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
    }
}
